<template>
  <BreadcrumbCL
    :all-white="allWhite"
    :full-background="fullBackground"
    :items="items"
    :with-brodos="withBrodos"
    home-name="Telekom Zubehörshop"
    :class="{ 'breadcrumb-cl--no-padding': noPadding }"
  />
</template>

<script>
import { Breadcrumb as BreadcrumbCL } from '@i22/td-longtail-vue-components';

export default {
  name: 'Breadcrumb',
  components: { BreadcrumbCL },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    noPadding: { type: Boolean },
    fullBackground: { type: Boolean },
    allWhite: { type: Boolean },
    withBrodos: { type: Boolean },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;
.breadcrumb-cl {
  &--no-padding {
    padding-inline: 0;
  }
}
</style>
